import {
    getOptions,
    InputField,
    IntegrationHl7VendorType, PaymentPlanIntervalType,
    ProviderIntegrationApi,
    ProviderIntegrationApiFromJSON, SelectField
} from "@enter/core";
import React, { useMemo } from 'react';
import {Formik, FormikHelpers, FormikProps, Form, Field} from "formik";
import * as Yup from "yup";
import * as S from './hl7-modal.styles';
import * as SH from '../shared.styles';

import _ from "lodash";

type FormProps = {
    vendorType: IntegrationHl7VendorType;
}

type IHl7ModalProps = {
    onSubmit: (vendorType: IntegrationHl7VendorType) => Promise<void>;
    onClose: () => void;
};

const Hl7Schema = Yup.object().shape({
    vendorType: Yup.mixed<IntegrationHl7VendorType>().oneOf(Object.values(IntegrationHl7VendorType))
});


export const Hl7Modal = ({onSubmit, onClose}: IHl7ModalProps) => {

    const onFormSubmit = async (values: FormProps, formik: FormikHelpers<FormProps>) => {
        formik.setSubmitting(true);
        try {
            await onSubmit(values.vendorType);
        } finally {
            formik.setSubmitting(false);
        }
    };

    const initialValues: FormProps = useMemo(() => {
        return {
            vendorType: IntegrationHl7VendorType.ECW
        };
    }, []);

    return (
        <Formik initialValues={initialValues} validationSchema={Hl7Schema} onSubmit={onFormSubmit}>
            {(formik: FormikProps<FormProps>) => (
                <S.DialogBody>
                    <S.InputGroup>
                        <S.Label>Vendor Type</S.Label>
                        <S.FormField
                            name="vendorType"
                            component={SelectField}
                            options={getOptions(IntegrationHl7VendorType)}
                            required={true}
                        />
                    </S.InputGroup>
                    <S.ButtonGroup
                        changed={true}
                        useNotify={false}
                        onCancel={onClose}
                        onSave={formik.submitForm}
                        saveLabel="Save"
                    />
                </S.DialogBody>
            )}
        </Formik>
    );
};